import { Component, input } from '@angular/core';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss',
})
export class ListComponent {
  readonly items = input<string[] | undefined>(undefined);
  readonly type = input<'ordered' | 'unordered'>('unordered');
}
